<main>
  <img
    alt="Estamos carregando suas informações!"
    [cdsSource]="'assets/common/shared/validation.svg'"
  />
  <section>
    @if (this.loading()) {
      <div class="loader"></div>
    }
    <p [innerHTML]="currentMessage$ | async"></p>
  </section>
</main>
